import { Routes } from '@angular/router';
import { authCognitoGuard } from 'src/app/auth/auth-cognito.guard';
import { ConfigurationPageComponent } from './configuration-page/configuration-page.component';

/** Standalone routes for org configuration. */
export const configurationRoutes: Routes = [
  {
    path: 'configuration',
    pathMatch: 'full',
    component: ConfigurationPageComponent,
    canActivate: [authCognitoGuard],
  },
];
